import { render } from "./ModalPfe.vue?vue&type=template&id=0a229e4e"
import script from "./ModalPfe.vue?vue&type=script&lang=js"
export * from "./ModalPfe.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__